"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _draftJs = require("draft-js"),
    getContentState = function getContentState(editorState) {
  var contentState = editorState.getCurrentContent(),
      json = (0, _draftJs.convertToRaw)(contentState),
      plainText = contentState.getPlainText();
  return {
    json: json,
    plainText: plainText
  };
},
    _default = getContentState;

exports["default"] = _default;